import { AppText } from '../../components/AppText';
import { AppTextField } from '../../components/AppTextField';
import { InlineNotice } from '../../components/InlineNotice';
import { PrimaryButton } from '../../components/PrimaryButton';
import { Strings } from '../../strings';

import { canSubmit } from './ForgotPasswordState';
import { useForgotPassword } from './useForgotPassword';

export function ForgotPasswordScreen({ onBack }: { onBack: () => void }) {
  const model = useForgotPassword();

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        void model.submit();
      }}
      style={{ display: 'flex', flexDirection: 'column', padding: '0 var(--space-6)' }}
    >
      <AppText as="h1" style="titleL">
        {Strings.forgotPasswordTitle}
      </AppText>

      <AppText
        color="var(--text-secondary)"
        sx={{ marginTop: 'var(--space-2)', marginBottom: 'var(--space-6)' }}
      >
        {Strings.forgotPasswordBody}
      </AppText>

      {model.state.isSent ? (
        <InlineNotice text={Strings.forgotPasswordSent} tone="info" />
      ) : (
        <>
          {model.state.error !== null ? (
            <div style={{ marginBottom: 'var(--space-4)' }}>
              <InlineNotice text={model.state.error} tone="error" />
            </div>
          ) : null}

          <AppTextField
            label={Strings.labelEmail}
            value={model.state.email}
            onChange={model.email}
            inputMode="email"
            type="email"
            autoComplete="email"
          />

          <div style={{ marginTop: 'var(--space-6)' }}>
            <PrimaryButton
              type="submit"
              label={Strings.actionSend}
              enabled={canSubmit(model.state)}
              loading={model.state.isSubmitting}
            />
          </div>
        </>
      )}

      <button
        type="button"
        onClick={onBack}
        style={{
          marginTop: 'var(--space-4)',
          background: 'none',
          border: 'none',
          padding: 0,
          textAlign: 'left',
          color: 'var(--action-primary)',
          fontSize: '15px',
          lineHeight: '20px',
          fontWeight: 600,
        }}
      >
        {Strings.actionSignIn}
      </button>
    </form>
  );
}
